module.exports = __webpack_public_path__ + "static/media/ope_minnamari_870x1305.148e1c03.jpg";